<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          type="CONTA_FINANCEIRA"
          :dense="dense"
          label="Classe financeira"
          required
          class="rounded-tag-small"
          v-model="formData.contaFinanceira"/>
      </v-col>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          type="OPERACAO"
          label="Operação"
          required
          class="rounded-tag-small"
          v-model="formData.operacao"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
